export const SUMMARY_I18N_PREFIX = 'resources.incident-reports.show.summary'
export const LIGHT_CARD_BORDER = 'inset 0 0 0 1px rgba(148, 163, 184, 0.14), 0 14px 32px rgba(15, 23, 42, 0.05)'
